import { Component, ComponentInterface, Host, h, Element } from '@stencil/core';
import { Lazy, LazyHost } from 'st-lazy';

@Component({
  tag: 'snl-social-btns',
  styleUrl: 'snl-social-btns.scss',
  shadow: false,
})
export class SnlSocialBtns implements ComponentInterface {
  @LazyHost() @Element() host: HTMLDivElement;

    socialLinks: any = [
        {
          title: "Facebook",
          link: "https://www.facebook.com/SandiaLabs",
          attr: {
            className: "fab fa-facebook-f",
            rel: "noopener noreferrer",
            target: "_blank",
          },
        },
        {
          title: "Twitter",
          link: "https://x.com/SandiaLabs",
          attr: {
            className: "fab fa-twitter",
            rel: "noopener noreferrer",
            target: "_blank",
          },
        },
        {
          title: "YouTube",
          link: "https://www.youtube.com/SandiaLabs",
          attr: {
            className: "fab fa-youtube",
            rel: "noopener noreferrer",
            target: "_blank",
          },
        },
        {
          title: "Flickr",
          link: "https://www.flickr.com/SandiaLabs",
          attr: {
            className: "fab fa-flickr",
            rel: "noopener noreferrer",
            target: "_blank",
          },
        },
        {
          title: "Instagram",
          link: "https://www.instagram.com/SandiaLabs",
          attr: {
            className: "fab fa-instagram",
            rel: "noopener noreferrer",
            target: "_blank",
          },
        },
        {
          title: "LinkedIn",
          link: "https://www.linkedin.com/company/sandia-national-laboratories",
          attr: {
            className: "fab fa-linkedin",
            rel: "noopener noreferrer",
            target: "_blank",
          },
        },
        {
          title: "RSS",
          link: "https://share-ng.sandia.gov/news/resources/news_releases/feed",
          attr: {
            className: "fas fa-rss",
            rel: "noopener noreferrer",
            target: "_blank",
          },
        },
      ];
    
      getSocialLinks() {
          const hasBlueClass = this.host.className.indexOf('social-icons__blue') > -1;
        const formatLinkBlocks = ({ title, link, attr }, index) => {
          const { className, rel, target } = attr;
          return (
            <li>
              <a
                class={className}
                rel={rel}
                target={target}
                aria-label={title}
                title={title}
                href={link}
              >
                  {hasBlueClass && <span>{title}</span>}
              </a>
            </li>
          );
        };
    
        return (
          <ul class="social-icons">
            {this.socialLinks && this.socialLinks.map(formatLinkBlocks)}
          </ul>
        );
      }
  @Lazy() render() {
    return (
      <Host>
        {this.getSocialLinks()}
      </Host>
    );
  }

}
